import style from "./Partnership.module.css";
import partnershiptitle from "../../assets/images/partnershiptitle.png";
import bank1 from "../../assets/images/bank/1.png";
import bank2 from "../../assets/images/bank/2.png";
import bank3 from "../../assets/images/bank/3.png";
import bank4 from "../../assets/images/bank/4.png";

import swiperLeftButton from "../../assets/images/swiper-left-button.png";
import swiperRightButton from "../../assets/images/swiper-right-button.png";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, { Pagination, Navigation } from "swiper";

// Import Swiper styles
//import 'swiper/css';

import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "./Partnership.css";

import { useState, useEffect } from "react";
import request from "../../common/request";

SwiperCore.use([Pagination, Navigation]);

export default function Main() {
  const [list, setList] = useState([]);
  useEffect(() => {
    request.getColumnList("合作伙伴").then((result) => {
      console.log(result.data);
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data;
        setList(data);
      }
      console.log("list", data);
    });
  }, []);

  return (
    <>
      <div className={style.mainbox}>
        <img
          src={partnershiptitle}
          style={{ width: "150px", marginLeft: "30px" }}
        />
        <div className={style.swiperc}>
          <Swiper
            className={style.swiper}
            spaceBetween={10}
            slidesPerView={4}
            navigation={{
              nextEl: ".swiper-button-next1",
              prevEl: ".swiper-button-prev1",
              disabledClass: "disable", // 当导航按钮变为不可用时添加的class
            }}
            loop={true}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
          >
            {list.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <img src={item.pic} style={imgStyle} />
                </SwiperSlide>
              );
            })}

            {/* <SwiperSlide>
              <img src={bank2} style={imgStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={bank3} style={imgStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={bank4} style={imgStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={bank1} style={imgStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={bank2} style={imgStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={bank3} style={imgStyle} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={bank4} style={imgStyle} />
            </SwiperSlide> */}
          </Swiper>
          <div className="swiper-button1 swiper-button-prev1">
            <img src={swiperLeftButton} />
          </div>
          <div className="swiper-button1 swiper-button-next1">
            <img src={swiperRightButton} />
          </div>
        </div>
      </div>
    </>
  );
}
const imgStyle = {
  width: "230px",
};
